import React from 'react';
import {Layout} from 'antd';
import {Routes, Route} from 'react-router-dom';
import ProtectedRoute from '../ProtectedRoute';
import PageContent from '../PageContent';

// 导入产品主档页面
import ProductPage from '../../pages/Product';
// 導入認證主檔頁面
import CertificationPage from '../../pages/Certification';
// 導入會籍主檔頁面
import MembershipPage from '../../pages/Membership';
import MemberDetailPage from '../../pages/Membership/MemberDetail';
import Committee from "../../pages/Committee";
import EventPage from "../../pages/Event";
// 導入比價證明書列印頁面
import PriceCertificatePage from "../../pages/PriceCertificate";
// 導入會員級數錯誤檢驗頁面
import MemberLevelCheckPage from "../../pages/MemberLevelCheck";
// 導入會員組織統計頁面
import MemberStatisticsPage from "../../pages/MemberStatistics";
// 導入會員名錄匯出頁面
import MemberDirectoryExportPage from "../../pages/MemberDirectoryExport";
import ZongJiuExportPage from "../../pages/ZongJiuExport";
// 導入系統管理頁面
import ParameterPage from '../../pages/SystemAdmin/Parameter';
import HomePage from 'pages/Home';
//import {UserRole} from "../../model/test";
import UserPage from "../../pages/User";

const {Content} = Layout;

/**
 * CustomerContent Component
 *
 * Renders the main content area of the application.
 * Contains routing for different pages with scrollable content area.
 */
const CustomerContent: React.FC = () => {
    return (
        <Content className="main-content">
            <Routes>
                {/* 首頁所有角色可訪問 */}
                <Route path="/" element={
                    <ProtectedRoute>
                        <PageContent>
                            <HomePage/>
                        </PageContent>
                    </ProtectedRoute>
                }/>

                {/* 會員檔案維護與查詢路由 */}
                <Route path="/membership-master" element={
                    <ProtectedRoute
                        // requiredRoles={[1, 2] as UserRole[]}
                    >
                        <PageContent>
                            <MembershipPage/>
                        </PageContent>
                    </ProtectedRoute>
                }/>

                {/* 會員詳細資料路由 */}
                <Route path="/membership/detail/:membershipId" element={
                    <ProtectedRoute
                        // requiredRoles={[1, 2] as UserRole[]}
                    >
                        <PageContent>
                            <MemberDetailPage/>
                        </PageContent>
                    </ProtectedRoute>
                }/>

                {/* 具體路由測試 - 直接硬編碼會員 ID */}
                <Route path="/membership/detail/test" element={
                    <ProtectedRoute>
                        <PageContent>
                            <MemberDetailPage/>
                        </PageContent>
                    </ProtectedRoute>
                }/>

                <Route path="/product-master" element={
                    <ProtectedRoute
                        // requiredRoles={[1, 3] as UserRole[]}
                    >
                        <PageContent>
                            <ProductPage/>
                        </PageContent>
                    </ProtectedRoute>
                }/>

                <Route path="/certificate-master" element={
                    <ProtectedRoute
                        // requiredRoles={[1, 4] as UserRole[]}
                    >
                        <PageContent>
                            <CertificationPage/>
                        </PageContent>
                    </ProtectedRoute>
                }/>

                {/* 其他路由 */}
                <Route path="/price-certificate" element={
                    <ProtectedRoute
                        // requiredRoles={[1, 5] as UserRole[]}
                    >
                        <PageContent>
                            <PriceCertificatePage />
                        </PageContent>
                    </ProtectedRoute>
                }/>

                <Route path="/member-grade-check" element={
                    <ProtectedRoute
                        // requiredRoles={[1, 2] as UserRole[]}
                    >
                        <PageContent>
                            <MemberLevelCheckPage />
                        </PageContent>
                    </ProtectedRoute>
                }/>

                <Route path="/member-statistics" element={
                    <ProtectedRoute
                        // requiredRoles={[1, 2, 5] as UserRole[]}
                    >
                        <PageContent>
                            <MemberStatisticsPage />
                        </PageContent>
                    </ProtectedRoute>
                }/>

                {/* 會員名錄匯出路由 */}
                <Route path="/member-directory-export" element={
                    <ProtectedRoute
                        // requiredRoles={[1, 2] as UserRole[]}
                    >
                        <PageContent>
                            <MemberDirectoryExportPage />
                        </PageContent>
                    </ProtectedRoute>
                }/>

                <Route path="/zongjiu-export" element={
                    <ProtectedRoute><PageContent><ZongJiuExportPage /></PageContent></ProtectedRoute>
                }/>

                {/* 專業委員會路由 */}
                <Route path="/committee" element={
                    <ProtectedRoute
                        // requiredRoles={[1, 3, 4] as UserRole[]}
                    >
                        <PageContent>
                            <Committee/>
                        </PageContent>
                    </ProtectedRoute>
                }/>

                {/* 活動維護路由 */}
                <Route path="/association-activity" element={
                    <ProtectedRoute
                        // requiredRoles={[1, 5] as UserRole[]}
                    >
                        <PageContent>
                            <EventPage/>
                        </PageContent>
                    </ProtectedRoute>
                }/>

                {/* 系統管理設定路由 */}
                <Route path="/admin/users" element={
                    <ProtectedRoute>
                        <PageContent>
                            <UserPage/>
                        </PageContent>
                    </ProtectedRoute>
                }/>

                <Route path="/admin/permissions" element={
                    <ProtectedRoute>
                        <PageContent>
                            <div>權限設定</div>
                        </PageContent>
                    </ProtectedRoute>
                }/>

                <Route path="/admin/parameters" element={
                    <ProtectedRoute>
                        <PageContent>
                            <ParameterPage/>
                        </PageContent>
                    </ProtectedRoute>
                }/>

                <Route path="*" element={<PageContent>
                    <div>404 Not Found</div>
                </PageContent>}/>
            </Routes>
        </Content>
    );
};
export default CustomerContent;
